import { Box } from "@mui/material";
import DefaultText from "../../../../../../../components/typography/default-text";
import styles from "./styles.module.css";
import { premiosPorAno, getAnosPorColuna } from "./premiosPorAno";
import {
  sxAnoHeaderXs,
  sxCertificationItem,
  sxItalicTextXs,
  sxPremioIconPlaceholderXs,
  sxPremioIconXs,
} from "./sxProps";

const CertificationsMobile: React.FC = () => {
  const colunas = getAnosPorColuna(2);

  return (
    <div className={styles["certifications-content"]}>
      {colunas.map((anos, colIndex) => (
        <div key={colIndex} className={styles["certifications-column"]}>
          {anos.map((ano) => (
            <div key={ano} className={styles["ano-block"]}>
              <span className={styles["ano"]}>
                <DefaultText sx={sxAnoHeaderXs} component="span">{ano}</DefaultText>
              </span>
              {premiosPorAno[ano].map((premio, idx) => (
                <Box key={idx} sx={sxCertificationItem}>
                  {premio.icone ? (
                    <Box component="img" src={premio.icone} alt="" sx={sxPremioIconXs} />
                  ) : (
                    <Box sx={sxPremioIconPlaceholderXs} aria-hidden />
                  )}
                  <DefaultText sx={sxItalicTextXs}>{premio.nome}</DefaultText>
                </Box>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default CertificationsMobile;
